import {h} from 'preact';

export default function Gague (props) {
  const total = Math.floor(props.component.data.factMap["T!T"].aggregates[0].value);
  const tLabel = props.component.data.factMap["T!T"].aggregates[0].label;
  const lowerBound = props.component.meta.properties.visualizationProperties.breakPoints[0].breaks[0].lowerBound;
  const upperBound = props.component.meta.properties.visualizationProperties.breakPoints[0].breaks.slice().reverse()[0].upperBound;
  const upperBoundLabel = new Intl.NumberFormat("en-US").format(upperBound);
  const percentage = Math.floor((100  / upperBound) * total);
  return (
  <div class={"component--type__" + props.type}>
    { props.component.meta.header &&
      <p class="container--header">{props.component.meta.header}</p>
    }
    <div class={"pie-chart pct-" + percentage} aria-label={"This goal is" + percentage + "% complete"}>
      <div class="meter"></div>
    </div>
    <p class="progress">{tLabel} / {upperBoundLabel}</p>
    { props.component.meta.footer &&
      <p class="container--footer text-small">{props.component.meta.footer}</p>
    }
    </div>

  );
}
